import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { IconButton, InputAdornment, Link, TextField, Typography, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

import ViewScaffolding from '../common/ViewScaffolding';
import authApi from '../../api/authApi';
import api, { links } from '../../collums-components/api/config';
import { changePasswordViewStyles } from './styles';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const ChangePasswordView = ({ classes, history }) => {
    const [form, setForm] = useState({ password: '', confirmPassword: '' });
    const [errorMessage, setErrorMessage] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const { code } = useParams();

    const submit = async () => {
        setSubmitted(true);
        if (!form.password || !form.confirmPassword) {
            return;
        }
        if (form.password !== form.confirmPassword) {
            setErrorMessage("Passwords doesn't match");
            return;
        }
        try {
            const changePasswordResult = await authApi.changePassword({ password: form.password, code });
            const loginResult = await authApi.login({
                email: changePasswordResult.email.address,
                password: form.password
            });
            api.config({ headers: { Authorization: loginResult.token } });
            await authApi.getMe();
            window.location = `${links.calendarUrl}?token=${loginResult.token}`;
        } catch (error) {
            setErrorMessage('Something went wrong');
        }
    };

    const change = (property, value) => {
        setForm({ ...form, [property]: value });
        setErrorMessage(null);
    };

    return (
        <ViewScaffolding
            form={
                <form>
                    <TextField
                        id="password-input"
                        classes={{ root: classes.textField }}
                        InputLabelProps={{ className: classes.input }}
                        color="primary"
                        size="small"
                        type={showPassword ? 'text' : 'password'}
                        label="Password"
                        value={form.password}
                        onChange={event => change('password', event.target.value)}
                        onKeyDown={event => 13 === event.keyCode && submit()}
                        helperText={!form.password && submitted && 'A value must be provided'}
                        error={!form.password && submitted}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(prev => !prev)} edge="end">
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                    <TextField
                        id="confirm-password-input"
                        classes={{ root: classes.textField }}
                        InputLabelProps={{ className: classes.input }}
                        color="primary"
                        size="small"
                        type={showConfirmPassword ? 'text' : 'password'}
                        label="Confirm password"
                        value={form.confirmPassword}
                        onChange={event => change('confirmPassword', event.target.value)}
                        onKeyDown={event => 13 === event.keyCode && submit()}
                        helperText={!form.confirmPassword && submitted && 'A value must be provided'}
                        error={!form.confirmPassword && submitted}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowConfirmPassword(prev => !prev)} edge="end">
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </form>
            }
            link={
                <Link onClick={() => history.push('/login')}>
                    <Typography className={classes.link}>Login</Typography>
                </Link>
            }
            action={submit}
            label="Change password"
            description="Set new password"
            errorMessage={errorMessage}
        />
    );
};

ChangePasswordView.propTypes = {
    history: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired
};

export default withStyles(changePasswordViewStyles)(ChangePasswordView);
